'use strict';


function _removePanels(config) {
    var panel = document.getElementById(config.name);

    while (panel && panel.parentNode) {
        panel.parentNode.removeChild(panel);
        _removePanels(config);
    }
}

module.exports = _removePanels;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/util/remove-panels.js
 ** module id = 20
 ** module chunks = 0
 **/